import { render, staticRenderFns } from "./FormFile.vue?vue&type=template&id=4aa3150b&scoped=true"
import script from "./FormFile.vue?vue&type=script&lang=js"
export * from "./FormFile.vue?vue&type=script&lang=js"
import style0 from "./FormFile.vue?vue&type=style&index=0&id=4aa3150b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa3150b",
  null
  
)

export default component.exports